import { useEffect, useState, useCallback } from "react";
import axios, { AxiosError } from "axios";
import { apiV1Endpoint } from "../../../../api/v1/endpoints";
import { useSelector } from "react-redux";

export const useTurnoverLedger = ({ leaseId }) => {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState<number>(0);
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(5);
  // const [filters, setFilters] = useState<Partial<UseTurnoverLedgerParams>>(initialParams);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  let { refresh_renwal } = useSelector((state: any) => state.newBooking);
  // redux states

  const fetchLedger = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const { data: result } = await axios.post(`${apiV1Endpoint}/booking/turnoverReportList`, {
        page,
        limit,
        leaseId,
      });

      setData(result?.result?.data || []);
      setTotal(result?.result?.totalCount || 0);
      setLimit(result?.result?.perPage || 10);
      setPage(result?.result?.currentPage);
    } catch (err) {
      const axiosError = err as AxiosError;
      setError(
        axiosError.response?.data ? JSON.stringify(axiosError.response.data) : "Failed to fetch Turnover Ledger"
      );
    } finally {
      setLoading(false);
    }
  }, [page, limit]);

  useEffect(() => {
    fetchLedger();
  }, [refresh_renwal, page]);

  return {
    data,
    total,
    page,
    limit,
    loading,
    error,
    refetch: fetchLedger,
    setPage,
    setLimit,
  };
};
